import * as constants from './constants'

export const startReservationExtension = reservationId => ({
    type: constants.START_RESERVATION_EXTENSION,
    reservationId,
})

export const setExtensionDateTimeRange = (start, end) => ({
    type: constants.EXTENSION_DATE_TIME_RANGE_SET,
    start,
    end,
})

export const extendReservation = (reservation, history) => ({
    type: constants.EXTEND_RESERVATION,
    reservation,
    history,
})

export const extendedReservation = history => ({
    type: constants.EXTENDED_RESERVATION,
    history,
})

export const failedReservationExtension = extendingError => ({
    type: constants.FAILED_RESERVATION_EXTENSION,
    extendingError,
})

export const resetExtendingProgress = () => ({
    type: constants.RESET_EXTENDING_PROGRESS,
})
